import { Entity, Field } from '@adornis/baseql/decorators';
import { MongoEntity } from '@adornis/baseql/entities/mongoEntity';
import { selectionSet } from '@adornis/baseql/utils/queryGeneration';

@Entity()
export class User extends MongoEntity {
  static _class = 'User';
  static _collectionName = 'User';
  static get allFields() {
    return selectionSet(() => User, 1);
  }

  @Field(type => String) public _id!: string;
  @Field(type => String) public realName!: string;
  @Field(type => String) public password!: string;
  @Field(type => String) public consent!: string;

  // @Mutation(type => Boolean)
  // public static updateUsers(@Arg('mapping', type => [User]) mapping: User[]) {
  //   return async (gqlFields: string) => {
  //     logger.debug({}, 'received a mapping');
  //     mapping.map(async el => {
  //       const tryupdate = await el.save();
  //       if (!tryupdate) el.create();
  //       logger.info({ tryupdate: tryupdate, el: el }, 'update user');
  //     });
  //   };
  // }
}
